import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { getUserToken } from "../utils/utils";
const AddtoCart = React.lazy(() => import("../salesperson/AddtoCart"));
const ItemDetails = React.lazy(() => import("../salesperson/ItemDetails"));
const CheckOut = React.lazy(() => import("../salesperson/CheckOut"));
const Orders = React.lazy(() => import("../salesperson/Orders"));
const WMSOrderDetails = React.lazy(
  () => import("../salesperson/WMSOrderDetails"),
);
const LandingPage = React.lazy(() => import("../pages/LandingPage"));
const CardFeeSetup = React.lazy(() => import("../pages/CardFeeSetup"));
const IpConfiguration = React.lazy(() => import("../pages/IpConfiguration"));
const MerchantDashboard = React.lazy(
  () => import("../pages/MerchantDashboard"),
);
const EmpLogin = React.lazy(() => import("../salesperson/EmpLogin"));
const EmployeeDashboard = React.lazy(
  () => import("../salesperson/EmployeeDashboard"),
);
const SalespersonSetup = React.lazy(
  () => import("../salesperson/SalespersonSetup"),
);
const DeliverypersonSetup = React.lazy(
  () => import("../salesperson/DeliverypersonSetup"),
);
const AssignedCustomers = React.lazy(
  () => import("../salesperson/AssignedCustomers"),
);
const AssignedCustomerDetail = React.lazy(
  () => import("../salesperson/AssignedCustomerDetail"),
);
const AssignedCustomerTransactionDetails = React.lazy(
  () => import("../salesperson/AssignedCustomerTransactionDetails"),
);
const AddDepartment = React.lazy(() => import("../pages/Departments"));
const Products = React.lazy(() => import("../pages/Products"));
const BarcodeScale = React.lazy(() => import("../pages/BarcodeScale"));
const AddStore = React.lazy(() => import("../pages/StoreManagement"));
const AgentDashboard = React.lazy(() => import("../pages/AgentDashboard"));
const ContactUs = React.lazy(() => import("../pages/ContactUs"));
const StoreSetting = React.lazy(() => import("../pages/StoreSetting"));
const CustomerEngagement = React.lazy(
  () => import("../pages/CustomerEngagement"),
);
const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const ManageAgent = React.lazy(() => import("../pages/ManageAgent"));
const ManageMerchant = React.lazy(() => import("../pages/ManageMerchant"));
const PromotionManagement = React.lazy(
  () => import("../pages/PromotionManagement"),
);
const StoreList = React.lazy(() => import("../pages/StoreList"));
const TaxMangement = React.lazy(() => import("../pages/TaxMangement"));
const UserManagement = React.lazy(() => import("../pages/UserManagement"));
const UserSetting = React.lazy(() => import("../pages/UserSetting"));
const AddPos = React.lazy(() => import("../pages/PosManagement"));
const PosLogViewer = React.lazy(() => import("../pages/PosLogViewer"));
const AllPinPadList = React.lazy(() => import("../pages/AllPinPadList"));
const UploadPosApk = React.lazy(() => import("../pages/UploadPosApk"));
const EmployeePermission = React.lazy(
  () => import("../pages/EmployeePermission"),
);
const AddEmpRole = React.lazy(() => import("../pages/EmpRole"));
const AddEmployee = React.lazy(() => import("../pages/Employees"));
const AddFlag = React.lazy(() => import("../pages/Flag"));
const MassProductUpdate = React.lazy(
  () => import("../pages/MassProductUpdate"),
);
const CustomerDetail = React.lazy(() => import("../pages/CustomerDetail"));
const CustomerTransactionDetails = React.lazy(
  () => import("../pages/CustomerTransactionDetails"),
);
const CustomerGroup = React.lazy(() => import("../pages/CustomerGroup"));
const PosListStoreWise = React.lazy(() => import("../pages/PosListStoreWise"));
const ShiftReport = React.lazy(() => import("../reports/ShiftReport"));
const SalesReport = React.lazy(() => import("../reports/SalesReport"));
const ProductReport = React.lazy(() => import("../reports/ProductReport"));
const PayRollReport = React.lazy(() => import("../reports/PayRollReport"));
const ProductivityReport = React.lazy(
  () => import("../reports/ProductivityReport"),
);
const CommissionReport = React.lazy(
  () => import("../reports/CommissionReport"),
);
const PurchaseOrder = React.lazy(() => import("../pages/PurchaseOrder"));
const Payout = React.lazy(() => import("../pages/Payout"));
const TaxReport = React.lazy(() => import("../reports/TaxReport"));
const TransactionReport = React.lazy(
  () => import("../reports/TransactionReport"),
);
const CashDropReport = React.lazy(() => import("../reports/CashDropReport"));
const BatchReport = React.lazy(() => import("../reports/BatchReport"));
const ConaReport = React.lazy(() => import("../reports/ConaReport"));
const ProfitReport = React.lazy(() => import("../reports/ProfitReport"));
const ProfitByOrder = React.lazy(() => import("../reports/ProfitByOrder"));
const ClockInOutDetailsByDay = React.lazy(
  () => import("../reports/ClockInOutDetailsByDay"),
);
const OrderHistory = React.lazy(() => import("../pages/OrderHistory"));
const SignIn = React.lazy(() => import("../pages/SignIn"));
const PreviewOrder = React.lazy(() => import("../pages/PreviewOrder"));
const TransactionDetails = React.lazy(
  () => import("../reports/TransactionDetails"),
);
const BatchDetails = React.lazy(() => import("../reports/BatchDetails"));
const DepartmentReport = React.lazy(
  () => import("../reports/DepartmentReport"),
);
const ClockInOutReport = React.lazy(
  () => import("../reports/ClockInOutReport"),
);
const ClockInOutByRange = React.lazy(
  () => import("../reports/ClockInOutByRange"),
);
const PosCustomize = React.lazy(() => import("../pages/PosCustomize"));
const routesForSuperAdmin = {
  Dashboard: <Dashboard />,
  AddStore: <AddStore />,
  ContactUs: <ContactUs />,
  ManageAgent: <ManageAgent />,
  ManageMerchant: <ManageMerchant />,
  StoreList: <StoreList />,
  AddPos: <AddPos />,
  PosLogViewer: <PosLogViewer />,
  AllPinPadList: <AllPinPadList />,
  UploadPosApk: <UploadPosApk />,
  UserManagement: <UserManagement />,
  UserSetting: <UserSetting />,
  ShiftReport: <ShiftReport />,
  SalesReport: <SalesReport />,
  DepartmentReport: <DepartmentReport />,
  ProductReport: <ProductReport />,
  TaxReport: <TaxReport />,
  PayRollReport: <PayRollReport />,
  ProductivityReport: <ProductivityReport />,
};

const routesForEmployee = {
  EmployeeDashboard: <EmployeeDashboard />,
  AddEmployee: <AddEmployee />,
  AddEmpRole: <AddEmpRole />,
  AddDepartment: <AddDepartment />,
  AddFlag: <AddFlag />,
  Products: <Products />,
  BarcodeScale: <BarcodeScale />,
  AddStore: <AddStore />,
  PosListStoreWise: <PosListStoreWise />,
  StoreList: <StoreList />,
  EmployeePermission: <EmployeePermission />,
  CustomerEngagement: <CustomerEngagement />,
  AssignedCustomers: <AssignedCustomers />,
  AssignedCustomerDetail: <AssignedCustomerDetail />,
  AssignedCustomerTransactionDetails: <AssignedCustomerTransactionDetails />,
  Orders: <Orders />,
  AddtoCart: <AddtoCart />,
  ItemDetails: <ItemDetails />,
  CheckOut: <CheckOut />,
  PosCustomize: <PosCustomize />,
  IpConfiguration: <IpConfiguration />,
  PromotionManagement: <PromotionManagement />,
  CardFeeSetup: <CardFeeSetup />,
  TaxMangement: <TaxMangement />,
  UserManagement: <UserManagement />,
  UserSetting: <UserSetting />,
  MassProductUpdate: <MassProductUpdate />,
  CustomerDetail: <CustomerDetail />,
  CustomerTransactionDetails: <CustomerTransactionDetails />,
  CustomerGroup: <CustomerGroup />,
  Payout: <Payout />,
  PurchaseOrder: <PurchaseOrder />,
  SalesReport: <SalesReport />,
  ShiftReport: <ShiftReport />,
  DepartmentReport: <DepartmentReport />,
  ProductReport: <ProductReport />,
  TaxReport: <TaxReport />,
  ClockInOutByRange: <ClockInOutByRange />,
  PayRollReport: <PayRollReport />,
  ProductivityReport: <ProductivityReport />,
  CommissionReport: <CommissionReport />,
  ClockInOutReport: <ClockInOutReport />,
  ClockInOutDetailsByDay: <ClockInOutDetailsByDay />,
  TransactionDetails: <TransactionDetails />,
  TransactionReport: <TransactionReport />,
  CashDropReport: <CashDropReport />,
  BatchReport: <BatchReport />,
  BatchDetails: <BatchDetails />,
  ConaReport: <ConaReport />,
  ProfitReport: <ProfitReport />,
  ProfitByOrder: <ProfitByOrder />,
  OrderHistory: <OrderHistory />,
  PreviewOrder: <PreviewOrder />,
  StoreSetting: <StoreSetting />,
  ContactUs: <ContactUs />,
};
const routesForMerchant = {
  MerchantDashboard: <MerchantDashboard />,
  SalespersonSetup: <SalespersonSetup />,
  DeliverypersonSetup: <DeliverypersonSetup />,
  AddEmployee: <AddEmployee />,
  AddEmpRole: <AddEmpRole />,
  AddDepartment: <AddDepartment />,
  AddFlag: <AddFlag />,
  Products: <Products />,
  BarcodeScale: <BarcodeScale />,
  AddStore: <AddStore />,
  PosListStoreWise: <PosListStoreWise />,
  StoreList: <StoreList />,
  EmployeePermission: <EmployeePermission />,
  CustomerEngagement: <CustomerEngagement />,
  Orders: <Orders />,
  WMSOrderDetails: <WMSOrderDetails />,
  ItemDetails: <ItemDetails />,
  AddtoCart: <AddtoCart />,
  CheckOut: <CheckOut />,
  PosCustomize: <PosCustomize />,
  IpConfiguration: <IpConfiguration />,
  PromotionManagement: <PromotionManagement />,
  CardFeeSetup: <CardFeeSetup />,
  TaxMangement: <TaxMangement />,
  UserManagement: <UserManagement />,
  UserSetting: <UserSetting />,
  MassProductUpdate: <MassProductUpdate />,
  CustomerDetail: <CustomerDetail />,
  CustomerTransactionDetails: <CustomerTransactionDetails />,
  CustomerGroup: <CustomerGroup />,
  Payout: <Payout />,
  PurchaseOrder: <PurchaseOrder />,
  SalesReport: <SalesReport />,
  ShiftReport: <ShiftReport />,
  DepartmentReport: <DepartmentReport />,
  ProductReport: <ProductReport />,
  TaxReport: <TaxReport />,
  ClockInOutByRange: <ClockInOutByRange />,
  PayRollReport: <PayRollReport />,
  ProductivityReport: <ProductivityReport />,
  CommissionReport: <CommissionReport />,
  ClockInOutReport: <ClockInOutReport />,
  ClockInOutDetailsByDay: <ClockInOutDetailsByDay />,
  TransactionDetails: <TransactionDetails />,
  TransactionReport: <TransactionReport />,
  CashDropReport: <CashDropReport />,
  BatchReport: <BatchReport />,
  BatchDetails: <BatchDetails />,
  ConaReport: <ConaReport />,
  ProfitReport: <ProfitReport />,
  ProfitByOrder: <ProfitByOrder />,
  OrderHistory: <OrderHistory />,
  PreviewOrder: <PreviewOrder />,
  StoreSetting: <StoreSetting />,
  ContactUs: <ContactUs />,
};
const routesForAgent = {
  AgentDashboard: <AgentDashboard />,
  ManageMerchant: <ManageMerchant />,
  AddStore: <AddStore />,
  PromotionManagement: <PromotionManagement />,
  StoreList: <StoreList />,
  UserManagement: <UserManagement />,
  UserSetting: <UserSetting />,
  AddPos: <AddPos />,
  PosLogViewer: <PosLogViewer />,
  AllPinPadList: <AllPinPadList />,
  ShiftReport: <ShiftReport />,
  SalesReport: <SalesReport />,
  DepartmentReport: <DepartmentReport />,
  ProductReport: <ProductReport />,
  TaxReport: <TaxReport />,
  PayRollReport: <PayRollReport />,
  ProductivityReport: <ProductivityReport />,
  ContactUs: <ContactUs />,
};

const routesForSign = {
  SignIn: <SignIn />,
  EmpLogin: <EmpLogin />,
  LandingPage: <LandingPage />,
};

const ProtectedRoute = (props) => {
  const userData = useSelector((store) => store.userReducer.userData);
  const role = useSelector((store) => store?.userReducer?.userRole);
  const matchRoute = () => {
    const userToken = getUserToken();
    const token = userToken ? userToken : null;
    if (token && token !== null) {
      if (role === "super-admin" || role === "admin") {
        const component = routesForSuperAdmin[props.route] || (
          <Navigate to="/dashboard" />
        );
        return component;
      } else if (role === "merchant") {
        const component = routesForMerchant[props.route] || (
          <Navigate to="/merchant-dashboard" />
        );
        return component;
      } else if (role === "employee") {
        if (
          userData?.empRole === "Sales Person" ||
          userData?.empRole === "Delivery Person"
        ) {
          const component = routesForEmployee[props.route] || (
            <Navigate to="/employee-dashboard" />
          );
          return component;
        } else {
          const component = routesForMerchant[props.route] || (
            <Navigate to="/merchant-dashboard" />
          );
          return component;
        }
      } else if (role === "super-merchant") {
        const component = routesForMerchant[props.route] || (
          <Navigate to="/merchant-dashboard" />
        );
        return component;
      } else if (role === "agent") {
        const component = routesForAgent[props.route] || (
          <Navigate to="/agent-dashboard" />
        );
        return component;
      } else {
        return <Navigate to="/sign-in" />;
      }
    } else {
      const component = routesForSign[props.route] || (
        <Navigate to="/sign-in" />
      );
      return component;
    }
  };
  return matchRoute();
};
export default ProtectedRoute;
